<div class="main">
  <div [style.flex-grow]="1"></div>
  <smt-bankid
    mode="login"
    [domain]="environment.domain"
    [bankIdUrl]="environment.bankIdGatewayUrl"
    (accessToken)="service.login($event)"
  />
  <div [style.flex-grow]="1"></div>
</div>
